// @flow
import React, {Component} from 'react';

import {FormattedMessage} from 'react-intl';
import classNames from 'classnames';

import './PriceFilter.less';
import Slider from '../Slider/Slider';
import PriceInputs from '../PriceInputs/PriceInputs';
import {getLimitedMaxPrice, getLimitedMaxDisplayPrice} from './utils';

export type BoundsType = Array<number | null>;
type Props = {
    currency: string,
    hasDates: ?boolean,
    minPrice: ?number,
    maxPrice: ?number,
    onPriceChange: (BoundsType) => void,
    className: string,
    locale: string
};
type State = {
    activeHandleIndex: ?number
};

export const nullIfMaxBounds = (
    maxAllowedPrice: ?number,
    callback: (BoundsType) => any
) => {
    return (bounds: BoundsType) => {
        let newBounds: BoundsType = [];
        if (maxAllowedPrice && bounds[1] && bounds[1] >= maxAllowedPrice) {
            newBounds = [bounds[0], null];
        } else {
            newBounds = newBounds.concat(bounds);
        }
        callback(newBounds);
    };
};

export class PriceFilter extends Component<Props, State> {
    constructor() {
        super();

        this.state = {
            activeHandleIndex: null
        };
    }

    handleSetActiveHandle = (index: ?number) => {
        this.setState({
            activeHandleIndex: index
        });
    };

    render() {
        const {currency, onPriceChange, className, maxPrice} = this.props;
        const limitedMaxPrice = getLimitedMaxPrice(currency);

        const maxAllowedPrice = limitedMaxPrice;

        const maxDisplayPrice = getLimitedMaxDisplayPrice(
            maxAllowedPrice,
            maxPrice
        );
        const minPrice = this.props.minPrice || 0;
        const isMax = maxDisplayPrice >= maxAllowedPrice;

        const onChange = nullIfMaxBounds(maxAllowedPrice, onPriceChange);

        const classes = classNames(
            `PriceFilter PriceFilter--min-max-price-fields-test-V1`,
            {
                [className]: className
            }
        );

        return (
            <div
                role="menuitem"
                aria-labelledby={`filter-group-label-${className}`}
                className={classes}
            >
                <span
                    className="sr-only"
                    id={`filter-group-label-${className}`}
                >
                    <FormattedMessage
                        id={'filterBarPriceLabel'}
                        defaultMessage={'Price'}
                    />
                </span>
                <div className="PriceFilter__priceLabel">
                    <span className="PriceFilter__priceLabel__values">
                        <FormattedMessage
                            id={'pricePerNightLabel'}
                            defaultMessage={'Price per night'}
                        />
                    </span>
                </div>

                <div
                    className="PriceFilter__PriceInputs"
                    data-wdio="PriceFilter__PriceInputs"
                >
                    <PriceInputs
                        minPrice={minPrice}
                        maxPrice={maxDisplayPrice}
                        maxAllowedPrice={maxAllowedPrice}
                        isMax={isMax}
                        activeHandleIndex={this.state.activeHandleIndex}
                        onChange={onChange}
                    />
                </div>

                <div
                    className="PriceFilter__slider"
                    data-wdio="PriceFilter__slider"
                >
                    <Slider
                        className={'Slider--min-max-price-fields-test'}
                        start={minPrice}
                        stop={maxDisplayPrice}
                        max={limitedMaxPrice}
                        activeHandleIndex={this.state.activeHandleIndex}
                        step={10}
                        onChange={onChange}
                        onSetActiveHandle={this.handleSetActiveHandle}
                        edapLabel="nightly_price_slider"
                    />
                </div>
            </div>
        );
    }
}

export default PriceFilter;
